import AppConstants from '../config/app.constants';

let RouteStopService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/route-stop`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let updateRouteStop = (routeSequence, branchId) => {
        return $http
            .post(AppConstants.api + `/route-stop/update-route-stop`, {
                routeSequence,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let autoOptimizeRouteStops = (routeDate, routeId) => {
        return $http
            .post(AppConstants.api + `/route-stop/optimize-route-stop`, {
                routeDate,
                routeId
            })
            .then((res) => {
                return res.data
            })
    }

    let routeStopList = (routeId, routeDate, branchId) => {
        return $http
            .post(AppConstants.api + `/route-stop/get-route-stop-list`, {
                routeId,
                routeDate,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let stopPerformance = (searchText, startTime, endTime, branchId, sortASC, sortColumn, routeId, timezone, offset, limit, startDate, endDate) => {
        return $http
            .get(AppConstants.api + `/stop-performance/stop-performance`, {
                params: {
                    searchText, startTime, endTime, branchId, sortASC, sortColumn, routeId, timezone, offset, limit, startDate, endDate
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportStopPerformance = (searchText, startTime, endTime, branchId, sortASC, sortColumn, routeId, timezone, offset, limit, startDate, endDate) => {
        return $http
            .post(AppConstants.api + `/stop-performance/export-stop-performance`, {
                searchText, startTime, endTime, branchId, sortASC, sortColumn, routeId, timezone, offset, limit, startDate, endDate
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        updateRouteStop,
        autoOptimizeRouteStops,
        routeStopList,
        stopPerformance,
        exportStopPerformance
    };

};

RouteStopService.$inject = ['$http', '$q']

export default RouteStopService;


// WEBPACK FOOTER //
// ./client/app/services/route-stop.service.js